/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionResponse
 */
export interface SectionResponse {
    /**
     * 
     * @type {string}
     * @memberof SectionResponse
     */
    sectionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SectionResponse
     */
    sectionName?: string | null;
}

/**
 * Check if a given object implements the SectionResponse interface.
 */
export function instanceOfSectionResponse(value: object): value is SectionResponse {
    return true;
}

export function SectionResponseFromJSON(json: any): SectionResponse {
    return SectionResponseFromJSONTyped(json, false);
}

export function SectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
        'sectionName': json['sectionName'] === undefined ? undefined : json['sectionName'] === null ? null : json['sectionName'],
    };
}

export function SectionResponseToJSON(json: any): SectionResponse {
    return SectionResponseToJSONTyped(json, false);
}

export function SectionResponseToJSONTyped(value?: SectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionCode': value['sectionCode'],
        'sectionName': value['sectionName'],
    };
}

